import { Component } from '@angular/core';

/**
 * ProfileMeComponent
 */
@Component({
  selector: 'app-profile-me',
  templateUrl: './profile-me.component.html',
  styleUrls: ['./profile-me.component.css']
})
export class ProfileMeComponent {

}
